/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.sync.listRepos'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 1000, minimum: 1 }),
      500,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  repos: /*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Repo>((() => repo) as any)),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates all the DID, rev, and commit CID for all repos hosted by this service. Does not require auth; implemented by PDS and Relay. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Repo = {
  $type?: 'com.atproto.sync.listRepos#repo'
  did: l.DidString
  rev: l.TidString

  /**
   * Current repo commit CID
   */
  head: l.CidString
  active?: boolean

  /**
   * If active=false, this optional field indicates a possible reason for why the account is not active. If active=false and no status is supplied, then the host makes no claim for why the repository is no longer being hosted.
   */
  status?:
    | 'takendown'
    | 'suspended'
    | 'deleted'
    | 'deactivated'
    | 'desynchronized'
    | 'throttled'
    | l.UnknownString
}

export type { Repo }

const repo = /*#__PURE__*/ l.typedObject<Repo>(
  $nsid,
  'repo',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    rev: /*#__PURE__*/ l.string({ format: 'tid' }),
    head: /*#__PURE__*/ l.string({ format: 'cid' }),
    active: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    status: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: [
          'takendown',
          'suspended',
          'deleted',
          'deactivated',
          'desynchronized',
          'throttled',
        ]
      }>(),
    ),
  }),
)

export { repo }
